var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clinicUser)?_c('plus-clinic-settings',{ref:"clinicSetting"}):_c('doctor-setting-container')
}
var staticRenderFns = []

export { render, staticRenderFns }